export default __webpack_public_path__ + "static/media/botoes_laterais_04.5a815216.mp3";